import { createContext, useContext, type ParentProps } from "solid-js";
import { SourceCsvStatique } from "./source-csv-statique";
import type { SourcePortefeuille } from "./source";

/**
 * Point de composition : c'est le SEUL endroit où l'application choisit son
 * implémentation de source. Passer à une API reviendra à changer cette fonction,
 * pas les composants.
 */
export function creerSourceParDefaut(): SourcePortefeuille {
  return new SourceCsvStatique({ urlBase: `${import.meta.env.BASE_URL}donnees/` });
}

const ContexteSource = createContext<SourcePortefeuille>();

export function FournisseurSource(props: ParentProps<{ source: SourcePortefeuille }>) {
  // La source est fixée au montage, par conception : elle n'a pas à être réactive.
  // eslint-disable-next-line solid/reactivity
  return <ContexteSource.Provider value={props.source}>{props.children}</ContexteSource.Provider>;
}

export function useSource(): SourcePortefeuille {
  const source = useContext(ContexteSource);
  if (!source) throw new Error("useSource() doit être appelé sous <FournisseurSource>.");
  return source;
}
